import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Accordion from './Accordion';
import { accordionData } from './Content';
import RenderStructuredData from '../../utils/renderStructuredData';

const FriendlyQuestions = ({ customTitle }: { customTitle?: string }) => {
  const { t } = useTranslation('pricing');
  return (
    <>
      <RenderStructuredData
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: accordionData.map((item) => ({
            '@type': 'Question',
            name: t(item.title) as string,
            acceptedAnswer: {
              '@type': 'Answer',
              text: t(item.content) as string,
            },
          })),
        }}
      />
      <div style={{ margin: '2rem auto', width: '100%' }}>
        <h2 className="custom-heading-font-2 text-center mb-1">
          {customTitle ? <>{customTitle}</> : <>{t('pricing:FAQ') as string}</>}
        </h2>
        <div>
          {accordionData.map(({ title, content, key, isdivContainer }) => (
            <Accordion
              key={key}
              title={t(title) as string}
              content={t(content) as string}
              isdivContainer={isdivContainer}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FriendlyQuestions;
